<template>
  <div class="main_div" :key="componentKey">
    <Loading v-show="loading" />
    <div style="height: auto">
      <n-space vertical>
        <NCard style="margin-top: 20px; margin-left: 80px; border: 0px; min-width: 800px">
          <n-space item-style="display: flex;" align="center">
            <div style="font-size: 20px; font-weight: bold">매출 관리</div>
          </n-space>
          <div class="content_delimiter_line"></div>

          <n-space vertical style="margin-top: 10px">
            <n-space align="center" item-style="display: flex;">
              <n-form-item label="검색" style="min-width: 350px" label-placement="left">
                <n-input-group>
                  <n-select
                    v-model:value="searchTypeForType"
                    :options="searchOptionsForType"
                    style="width: 120px; padding-right: 10px"
                  />
                  <n-select v-model:value="searchType" :options="searchOptions" style="width: 120px" />
                  <n-input v-model:value="searchValue" placeholder="검색어를 입력하세요" clearable />
                </n-input-group>
              </n-form-item>

              <n-form-item label="결제(입금)일 선택" style="min-width: 300px" label-placement="left">
                <n-date-picker v-model:value="dateRange" type="daterange" clearable />
              </n-form-item>
              <n-form-item style="margin-bottom: 0" label-placement="left">
                <n-button type="primary" @click="fetchPaymentsByDateRange" :disabled="!dateRange"> 조회 </n-button>
              </n-form-item>
            </n-space>
          </n-space>
          <div v-if="showPaymentResults">
            <Loading v-show="listLoading" />
            <div v-if="!listLoading && error" class="error-message" style="margin-top: 10px">
              {{ error }}
            </div>
            <n-data-table
              v-if="!listLoading && !error && payments.length > 0"
              :columns="columns"
              :data="payments"
              :pagination="false"
              :bordered="false"
              style="margin-top: 10px"
            />
            <p v-if="!listLoading && !error && payments.length === 0" style="margin-top: 10px; text-align: center">
              선택된 기간에 해당하는 결제(입금) 데이터가 없습니다.
            </p>

            <div
              v-if="payments.length > 0 && !listLoading && !error"
              class="pagination-controls"
              style="margin-top: 15px; text-align: center"
            >
              <n-button @click="wrappedGoToPreviousPage" :disabled="currentPage === 1" style="margin-right: 8px">
                이전 페이지
              </n-button>
              <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
              <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage"> 다음 페이지 </n-button>
            </div>
          </div>
          <div v-else style="margin-top: 20px; text-align: center; color: #777">조회할 기간을 선택해주세요.</div>
        </NCard>
        <n-modal
          v-model:show="showOrgOrderDetailsModal"
          preset="card"
          style="width: 800px"
          title="견적 상세 정보"
          @after-leave="onOrgOrderDetailsModalClose"
        >
          <div v-if="selectedOrder" class="order-details-content">
            <n-descriptions label-placement="left" bordered :column="2" size="small">
              <n-descriptions-item label="견적명" :span="2">{{ selectedOrder.name }}</n-descriptions-item>
              <n-descriptions-item label="기관명">{{ selectedOrder.client.name }}</n-descriptions-item>
              <n-descriptions-item label="수신자 이메일">{{ selectedOrder.receiver_email }}</n-descriptions-item>
              <n-descriptions-item label="참조">{{ selectedOrder.cc || "N/A" }}</n-descriptions-item>
              <n-descriptions-item label="총 금액"
                >{{ selectedOrder.totalPrice.toLocaleString() }}원</n-descriptions-item
              >
              <n-descriptions-item label="상태">{{ common.getStatusString(selectedOrder.status) }}</n-descriptions-item>
              <n-descriptions-item label="생성일">
                {{ common.getYYYYMMDD2(new Date(Number(selectedOrder.createdDate))) }}
              </n-descriptions-item>
              <n-descriptions-item label="결제 방법" :span="2">
                {{
                  selectedOrder.payment_method?.type === "bank_deposit"
                    ? "계좌이체"
                    : selectedOrder.payment_method?.type || "N/A"
                }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="결제 계좌"
                :span="2"
              >
                {{ selectedOrder.payment_method.bank_name }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="입금자명"
                :span="2"
              >
                {{ selectedOrder.payment_method.deposit_name }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="입금예정일"
                :span="2"
              >
                {{ selectedOrder.payment_method.bank_date }}
              </n-descriptions-item>
            </n-descriptions>

            <h4 style="margin-top: 20px; margin-bottom: 10px">견적 항목</h4>
            <n-data-table
              :columns="orgOrderItemColumns"
              :data="selectedOrder.products"
              :pagination="false"
              :bordered="true"
              size="small"
            />

            <div style="text-align: right; margin-top: 20px">
              <n-button @click="closeOrgOrderDetailsModal" type="tertiary" style="margin-right: 10px"> 닫기 </n-button>
            </div>
          </div>
          <div v-else class="loading-indicator">상세 정보를 불러오는 중...</div>
        </n-modal>
        <n-modal
          v-model:show="showPersonalOrderDetailsModal"
          preset="card"
          style="width: 800px"
          title="신청 상세 정보"
          @after-leave="onPersonalOrderDetailsModalClose"
        >
          <div v-if="selectedOrder" class="order-details-content">
            <n-descriptions label-placement="left" bordered :column="2" size="small">
              <n-descriptions-item label="신청자">{{ selectedOrder.client.uid }}</n-descriptions-item>
              <n-descriptions-item label="수신자 이메일">{{
                selectedOrder.receiver_email || "검사 시 입력"
              }}</n-descriptions-item>
              <n-descriptions-item label="금액"
                >{{ Number(selectedOrder.totalPrice || 0).toLocaleString() }} 원</n-descriptions-item
              >
              <n-descriptions-item label="상태">{{ common.getStatusString(selectedOrder.status) }}</n-descriptions-item>
              <n-descriptions-item label="생성일">
                {{ common.getYYYYMMDD2(new Date(Number(selectedOrder.createdDate))) }}
              </n-descriptions-item>
              <n-descriptions-item label="결제 방법" :span="2">
                {{
                  selectedOrder.payment_method?.type === "bank_deposit"
                    ? "계좌이체"
                    : selectedOrder.payment_method?.type || "N/A"
                }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="결제 계좌"
                :span="2"
              >
                {{ selectedOrder.payment_method.bank_name }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="입금자명"
                :span="2"
              >
                {{ selectedOrder.payment_method.deposit_name }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="입금예정일"
                :span="2"
              >
                {{ selectedOrder.payment_method.bank_date }}
              </n-descriptions-item>
            </n-descriptions>

            <h4 style="margin-top: 20px; margin-bottom: 10px">신청 항목</h4>
            <n-data-table
              :columns="personalOrderItemColumns"
              :data="selectedOrder.products"
              :pagination="false"
              :bordered="true"
              size="small"
            />

            <div style="text-align: right; margin-top: 20px">
              <n-button @click="closePersonalOrderDetailsModal" type="tertiary" style="margin-right: 10px">
                닫기
              </n-button>
            </div>
          </div>
          <div v-else class="loading-indicator">상세 정보를 불러오는 중...</div>
        </n-modal>
      </n-space>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, h, computed, FunctionalComponent } from "vue";
import {
  NSpace,
  NCard,
  NButton,
  NDataTable,
  NModal,
  NSelect,
  NDescriptions,
  NDescriptionsItem,
  NDatePicker,
  NFormItem,
  useMessage,
  NTabs,
  NTabPane,
  useNotification,
  useDialog,
  DataTableColumns,
  NInputGroup,
  NInput,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import { getCallable, getRequestEndpoint } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useAuth } from "@/composables/useAuth";
import { QueryInfo, ChangeStatus } from "@/model/base";
import { Order, OrderItem, Payment } from "@/model/order";
import { usePagination } from "@/composables/usePagination";
import { USER_ROUTES } from "@/assets/route_constants";

const { loading } = useAuth();
const router = useRouter();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const componentKey = ref(0);

const dateRange = ref<[number, number] | null>(null);
const showPaymentResults = ref(false);

const showOrgOrderDetailsModal = ref(false);
const showPersonalOrderDetailsModal = ref(false);
const searchValue = ref<string | null>(null);

const searchTypeForType = ref("all");
const searchOptionsForType = [
  { label: "전체", value: "all" },
  { label: "기관", value: "body" },
  { label: "개인", value: "individual" },
];

const searchType = ref("client.name");

const searchOptions = [{ label: "주문자", value: "client.name" }];

const selectedOrder = ref<Order | null>(null);

const getPaymentsCallable = getCallable("getPayments");
const getOrderCallable = getCallable("getOrder");

const {
  paginatedItems: payments,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshPayments,
} = usePagination<Payment, { startDate?: string; endDate?: string }>(async (params) => getPayments(params), 10);

async function wrappedRefreshPayments(filters?: { status?: string }) {
  loading.value = true;
  await composableRefreshPayments(filters);
  loading.value = false;
}

const getPayments = async (params: any) => {
  if (searchTypeForType.value != "all") {
    params.searchKey = "type";
    params.searchValue = searchTypeForType.value.trim();
  }
  if (searchValue.value && searchValue.value.trim() !== "") {
    params.searchKey2 = searchType.value;
    params.searchValue2 = searchValue.value.trim();
  }
  return await getPaymentsCallable(params);
};

async function wrappedGoToNextPage() {
  if (!hasNextPage.value) return;
  loading.value = true;
  await composableGoToNextPage();
  loading.value = false;
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value <= 1) return;
  loading.value = true;
  await composableGoToPreviousPage();
  loading.value = false;
}

async function displayOrderDetails(order: Order) {
  selectedOrder.value = order;
  if (order.type == constant.orderType.INDIVIDUAL) {
    showPersonalOrderDetailsModal.value = true;
  } else {
    showOrgOrderDetailsModal.value = true;
  }
}

function closeOrgOrderDetailsModal() {
  showOrgOrderDetailsModal.value = false;
}

function closePersonalOrderDetailsModal() {
  showPersonalOrderDetailsModal.value = false;
}

async function fetchPaymentsByDateRange() {
  if (!dateRange.value) {
    message.error("기간을 선택해주세요.");
    return;
  }
  const [startTimestamp, endTimestamp] = dateRange.value;
  const startDate = startTimestamp.toString();
  const endDate = common.addDaysToTimestamp(endTimestamp, 1).toString();

  showPaymentResults.value = false;
  loading.value = true;
  await composableRefreshPayments({ startDate, endDate });
  showPaymentResults.value = true;
  loading.value = false;
}

const columns = [
  {
    title: "견적이름",
    key: "name",
    resizable: true,
  },
  {
    title: "주문자",
    resizable: true,
    render(row: Payment) {
      if (row.client) {
        return row.client.name;
      } else {
        return "";
      }
    },
  },
  {
    title: "결제(입금)일",
    key: "pay_date",
    resizable: true,
    render(row: Payment) {
      return common.getYYYYMMDD2(new Date(Number(row.pay_date)));
    },
  },
  {
    title: "주문금액",
    key: "totalPrice",
    resizable: true,
  },
  {
    title: "결제금액",
    key: "payment_price",
    resizable: true,
  },
  {
    title: "개인/기관",
    key: "type",
    resizable: true,
    render(row: Payment) {
      return common.getOrderType(row.type);
    },
  },
  {
    title: "",
    key: "actions",
    render(row: Payment) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => viewOrder(row),
        },
        { default: () => "주문정보보기" }
      );
    },
  },
];

const orgOrderItemColumns = [
  { title: "상품명", key: "name", resizable: true },
  {
    title: "단가",
    key: "unit_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.unit_price || 0).toLocaleString()}원`,
  },
  { title: "수량", key: "quantity", resizable: true },
  {
    title: "공급가액",
    key: "supply_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.supply_price || 0).toLocaleString()}원`,
  },
  {
    title: "비고",
    key: "notes",
    resizable: true,
    render: (row: OrderItem) => `${row.notes || ""}`,
  },
];
const personalOrderItemColumns = [
  { title: "상품명", key: "name", resizable: true },
  {
    title: "가격",
    key: "price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.price || 0).toLocaleString()}원`,
  },
];

async function viewOrder(payment: Payment) {
  loading.value = true;
  try {
    const result = await getOrderCallable({ SK: payment.order_id });
    if (common.evalFunctionResult(result)) {
      const order = common.getItemFromFunctionResult(result) as Order;
      displayOrderDetails(order);
    } else {
      notification.error({
        title: "정보 로딩 실패",
        description: common.getResultError(result) || "신청(견적) 정보를 불러오는데 실패했습니다.",
        duration: 3000,
      });
    }
  } catch (e: any) {
    notification.error({
      title: "오류 발생",
      description: e.message || "신청(견적) 정보 로딩 중 오류가 발생했습니다.",
      duration: 3000,
    });
  } finally {
    loading.value = false;
  }
}

async function handleTabChange(tabName: string) {
  await wrappedRefreshPayments();
}

onMounted(() => {
  wrappedRefreshPayments();
});
</script>

<style scope></style>
